<template>
  <div class="mb-4 text-left card p-2">
    <mdb-stepper :options="options" :steps="settingsStepper" @submit="submit" buttons id="new-group-stepper"
                 v-model="currentStep">
      <template #1>
        <h3 class="font-weight-bold pl-0 my-4">
          <strong>Welcome to your new group!</strong>
        </h3>
        <p>Use the icons above to step through the actions needed to complete your group set up. </p>

      </template>
      <template #2>
        <h3 class="font-weight-bold pl-0 my-4">
          <strong>Branding</strong>
        </h3>
        <p>
          <mdb-icon icon="check-circle" size="2x" v-if="checklist.avatarSet"/>
          <mdb-icon icon="ban" size="2x" v-if="!checklist.avatarSet"/>
          <router-link :to="'/group/' + group.vanityPath + '/image-library'">Set a Profile Picture</router-link>
          .
        </p>
        <p>
          <mdb-icon icon="check-circle" size="2x" v-if="checklist.bannerSet"/>
          <mdb-icon icon="ban" size="2x" v-if="!checklist.bannerSet"/>
          <router-link :to="'/group/' + group.vanityPath + '/designer'">Customize your banner</router-link>. A random
          image will be used unless you set a banner either from our library of banner images or you load your own.
        </p>
        <p>
          <mdb-icon icon="check-circle" size="2x" v-if="checklist.customizedHome"/>
          <mdb-icon icon="ban" size="2x" v-if="!checklist.customizedHome"/>
          <router-link :to="'/group/' + group.vanityPath + '/designer'">Customize the lay out</router-link>
          of your home page.
        </p>

      </template>

      <template #3>
        <h3 class="font-weight-bold pl-0 my-4">
          <strong>Important Settings</strong>
        </h3>
        <p>
          <mdb-icon icon="check-circle" size="2x" v-if="checklist.hasCategories"/>
          <mdb-icon icon="ban" size="2x" v-if="!checklist.hasCategories"/>
          <router-link :to="'/group/' + group.vanityPath + '/basics'">Set up categories</router-link>
          to help people find your group.
        </p>
        <p>
          <mdb-icon icon="check-circle" size="2x" v-if="checklist.hasDocs"/>
          <mdb-icon icon="ban" size="2x" v-if="!checklist.hasDocs"/>
          <router-link :to="'/group/' + group.vanityPath + '/content'">Create documents</router-link>
          to have items to put on your
          group's home page and to provide useful information to your members.
        </p>
      </template>
      <template #4>
        <h3 class="font-weight-bold pl-0 my-4">
          <strong>Done!</strong>
        </h3>
        <div v-if="!settings.newGroupApproval">
          <p v-if="group.isPrivate">
            Note: Your group is still set as private. This means nobody will be able to
            find it without this secret link: <a :href="group.absoluteUrl">{{ group.absoluteUrl }}</a>. If that's what
            you want,
            you don't need to do anything else. If you wish to make your group publicly visible, head over to
            <router-link :to="group.homeUrl+'/basics'">settings</router-link>
            .
          </p>
          <p>
            If you have email addresses of people you would like to join, you may invite them to join
            <router-link :to="group.homeUrl+'/invitations'">on the invitations page</router-link>
            .
          </p>
        </div>

      </template>
    </mdb-stepper>
  </div>

</template>

<script>
import {
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbIcon,
  mdbInput,
  mdbStepper,
  mdbView
} from 'mdbvue';
import api from '../../services/groupsPlaceApi.js'

export default {
  name: 'group-checklist',
  components: {
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardImage,
    mdbCardFooter,
    mdbView,
    mdbIcon,
    mdbInput,
    mdbStepper
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    addLink: {
      type: String,
      default: null
    }
  },
  computed: {
    settings() {
      return this.$store.state.settings
    }
  },
  data() {
    return {
      currentStep: 1,
      step1Complete: false,
      step2Complete: false,
      step3Complete: false,
      step4Complete: false,
      settingsStepper: [
        {icon: "folder", far: true, name: "Welcome!"},
        {icon: "image", far: true, name: "Branding"},
        {icon: "pencil-alt", name: "Check Settings"},
        {icon: "check", name: "Finish"}
      ],
      options: {
        stepBtn: {color: "info", active: "amber", iconClass: "white-text"},
        nextBtn: {outline: "info", icon: "chevron-right"},
        prevBtn: {outline: "info", icon: "chevron-left"},
        submitBtn: {color: "amber", icon: "check", text: "Remove Checklist"},
        lineColor: "amber"
      },
      checklist: {
        avatarSet: false, bannerSet: false, accessToken: "", hasDocs: false,
        customizedHome: false, hasCategories: false
      },
    }
  },
  beforeMount() {
    api.get("/group/checklistStatus/" + this.group.vanityPath).then(
      (response) => {
        this.checklist = response.data
        this.step1Complete = (this.checklist.avatarSet || this.checklist.bannerSet ||
          this.checklist.customizedHome || this.checklist.hasCategories || this.checklist.hasDocs)
        this.step2Complete = this.checklist.avatarSet && this.checklist.bannerSet && this.checklist.customizedHome
        this.step3Complete = (this.checklist.hasCategories && this.checklist.hasDocs)
        if (this.step1Complete) {
          if (!this.step2Complete) this.currentStep = 2
          else if (!this.step3Complete) this.currentStep = 3
          else this.currentStep = 4
        }
      },
      (error) => {
        console.log(this.error.response)
      }
    );
  },
  methods: {
    submit() {
      this.$store.dispatch("setExecuting", true)
      api.get("/group/checklistComplete/" + this.group.vanityPath).then(
        (results) => {
          this.group.showChecklist = false
        },
        (error) => {
          this.$notify.error({message: "Could not mark complete at this time.", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};
</script>

